// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5e9bfea9","453":"d1e0547d","732":"bbae25a2","977":"fcb57aff"}[chunkId] + ".chunk.js";
};